import 'assets/styles/Print.css';

const FormHeader = () => {
  return (
    <div className="print-header"></div>
  );
};

export default FormHeader;